import { alpha, useTheme } from '@mui/material/styles';
import { GuideArea } from 'src/components/guide/ServiceGuide';
import { useGuideStyles } from 'src/components/guide/styles/guideStyles';

function useGetGuideInfo() {
  const guideStyles = useGuideStyles();
  const theme = useTheme();

  function getMainVisualAreas(): GuideArea[] {
    return [
      {
        id: 'bgPath',
        label: 'Background Image & Video',
        description: '메인 화면의 배경으로 표시됩니다. 이미지나 비디오를 업로드할 수 있습니다.',
        x: '0%',
        y: '0%',
        width: '100%',
        height: '100%',
        fieldName: 'bgPath',
        style: guideStyles.media,
      },
      {
        id: 'mainText',
        label: 'Main Text',
        description: '화면 중앙에 강조되어 표시되는 주요 메시지입니다.',
        x: '15%',
        y: '20%',
        width: '76%',
        height: '20%',
        fieldName: 'mainText',
        fontSize: '24px',
        style: guideStyles.primary,
      },
      {
        id: 'subText',
        label: 'Sub Text',
        description: '메인 텍스트 아래에 표시되는 첫 번째 부가 설명입니다.',
        x: '15%',
        y: '50%',
        width: '76%',
        height: '8%',
        fieldName: 'subText',
        fontSize: '16px',
        style: guideStyles.secondary,
      },
    ];
  }

  function getBusinessAreas(): GuideArea[] {
    const thumbnailStartX = '18%';
    const thumbnailEndX = '82%';
    const imageX = thumbnailStartX;
    const imageWidth = `${82 - 18}%`;

    return [
      {
        id: 'background',
        label: 'Background',
        description: '',
        x: '15%',
        y: '5%',
        width: '70%',
        height: '90%',
        fieldName: 'background',
        showBadge: false,
        style: guideStyles.background,
      },
      {
        id: 'title',
        label: 'Title',
        description: '비즈니스의 제목을 입력합니다.',
        x: '25%',
        y: '6%',
        width: '50%',
        height: '10%',
        fieldName: 'title',
        fontSize: '24px',
        style: guideStyles.primary,
      },
      {
        id: 'summary',
        label: 'Summary',
        description: '비즈니스의 간단한 요약 설명을 입력합니다.',
        x: '25%',
        y: '17%',
        width: '50%',
        height: '8%',
        fieldName: 'summary',
        fontSize: '16px',
        style: guideStyles.secondary,
      },
      {
        id: 'desc',
        label: 'Description',
        description: '비즈니스의 상세 설명을 입력합니다.',
        x: '25%',
        y: '27%',
        width: '50%',
        height: '6%',
        fieldName: 'desc',
        fontSize: '13px',
        style: guideStyles.description,
      },
      {
        id: 'detailImage',
        label: 'detailImage Image',
        description: '비즈니스 목록에서 보여지는 상세 이미지입니다.',
        x: imageX,
        y: '35%',
        width: imageWidth,
        height: '20%',
        fieldName: 'detailImage',
        style: guideStyles.media,
      },
      {
        id: 'subContentTitle',
        label: 'SubContent Title',
        description: '서브 컨텐츠의 제목을 입력합니다.',
        x: '25%',
        y: '58%',
        width: '50%',
        height: '8%',
        fieldName: 'title',
        fontSize: '12px',
        style: guideStyles.secondary,
      },
      {
        id: 'subContentDescript',
        label: 'SubContent Description',
        description: '서브 컨텐츠의 설명을 입력합니다.',
        x: '25%',
        y: '68%',
        width: '50%',
        height: '6%',
        fieldName: 'descript',
        fontSize: '13px',
        style: guideStyles.description,
      },
      {
        id: 'subContentImages',
        label: 'Desktop & Mobile Images',
        description: '서브 컨텐츠의 데스크탑/모바일 이미지를 업로드합니다.',
        x: imageX,
        y: '77%',
        width: imageWidth,
        height: '15%',
        fieldName: 'desktopImagePath & mobileImagePath',
        style: guideStyles.media,
      },
    ];
  }
  function getBusinessThumbnail(): GuideArea[] {
    const cardWidth = '20%';
    const cardHeight = '45%';
    const centerY = '20%';
    const sideY = '30%';

    return [
      // 왼쪽 카드
      {
        id: 'leftCard',
        label: '',
        description: '왼쪽 카드 영역입니다.',
        x: '18%',
        y: sideY,
        width: cardWidth,
        height: cardHeight,
        fieldName: 'left',
        showBadge: false,
        style: guideStyles.secondary,
      },
      // 가운데 카드 (썸네일)
      {
        id: 'thumbPath',
        label: 'Thumbnail Image',
        description: '메인화면에 노출되는 사업별 썸네일 이미지입니다.',
        x: '40%',
        y: centerY,
        width: cardWidth,
        height: cardHeight,
        fieldName: 'thumbPath',
        style: guideStyles.media,
      },
      // 오른쪽 카드
      {
        id: 'rightCard',
        label: '',
        description: '오른쪽 카드 영역입니다.',
        x: '62%',
        y: sideY,
        width: cardWidth,
        height: cardHeight,
        fieldName: 'right',
        showBadge: false,
        style: guideStyles.secondary,
      },
    ];
  }

  function getTopCategoryAreas(): GuideArea[] {
    return [
      {
        id: 'categoryNm',
        label: 'Category Name',
        description: '카테고리의 이름을 입력합니다.',
        x: '10%',
        y: '5%',
        width: '80%',
        height: '15%',
        fieldName: 'categoryNm',
        fontSize: '24px',
        style: guideStyles.primary,
      },
      {
        id: 'mainTitle',
        label: 'Main Title',
        description: '카테고리의 메인 제목을 입력합니다.',
        x: '10%',
        y: '25%',
        width: '80%',
        height: '12%',
        fieldName: 'mainTitle',
        fontSize: '16px',
        style: guideStyles.description,
      },
    ];
  }
  function getCategoryAreas(): GuideArea[] {
    const tabStyle = {
      ...guideStyles.secondary,
      fontSize: '11px',
      borderRadius: '30px',
      border: `2px solid ${theme.palette.divider}`,
      backgroundColor: alpha(theme.palette.secondary.main, 0.05),
    };

    // 탭 레이아웃 계산
    const tabWidth = '19.5%';
    const totalTabs = 4;
    const totalTabsWidth = Number(tabWidth.replace('%', '')) * totalTabs; // 72%
    const startX = (100 - totalTabsWidth) / 2; // (100% - 72%) / 2 = 14%

    return [
      {
        id: 'prevTab',
        label: '',
        description: '이전 카테고리입니다.',
        x: `${startX}%`, // 14%
        y: '5%',
        width: tabWidth,
        height: '10%',
        fieldName: '',
        showBadge: false,
        style: tabStyle,
      },
      {
        id: 'prevTab2',
        label: '',
        description: '이전 카테고리입니다.',
        x: `${startX + 20}%`, // 34%
        y: '5%',
        width: tabWidth,
        height: '10%',
        fieldName: '',
        showBadge: false,
        style: tabStyle,
      },
      {
        id: 'categoryNm',
        label: 'Category Name',
        description: '카테고리의 이름을 입력합니다.',
        x: `${startX + 40}%`, // 54%
        y: '5%',
        width: tabWidth,
        height: '10%',
        fieldName: 'categoryNm',
        fontSize: '20px',
        style: {
          ...guideStyles.secondary,
          borderRadius: '30px',
          border: `2px solid ${theme.palette.primary.main}`,
          backgroundColor: alpha(theme.palette.primary.main, 0.1),
        },
      },
      // 오른쪽 탭 (비활성)
      {
        id: 'nextTab',
        label: '',
        description: '다음 카테고리입니다.',
        x: `${startX + 60}%`, // 74%
        y: '5%',
        width: tabWidth,
        height: '10%',
        fieldName: '',
        showBadge: false,
        style: tabStyle,
      },
      {
        id: 'subTitle',
        label: 'Sub Title',
        description: '카테고리의 서브 제목을 입력합니다.',
        x: '10%',
        y: '25%',
        width: '80%',
        height: '10%',
        fieldName: 'subTitle',
        fontSize: '20px',
        style: guideStyles.secondary,
      },
      {
        id: 'mainTitle',
        label: 'Main Title',
        description: '카테고리의 메인 제목을 입력합니다.',
        x: '10%',
        y: '40%',
        width: '80%',
        height: '12%',
        fieldName: 'mainTitle',
        fontSize: '24px',
        style: guideStyles.primary,
      },
      {
        id: 'mainDesc',
        label: 'Main Description',
        description: '카테고리의 메인 설명을 입력합니다.',
        x: '10%',
        y: '55%',
        width: '80%',
        height: '10%',
        fieldName: 'mainDesc',
        fontSize: '16px',
        style: guideStyles.description,
      },
      {
        id: 'subDesc',
        label: 'Sub Description',
        description: '카테고리의 서브 설명을 입력합니다.',
        x: '10%',
        y: '70%',
        width: '80%',
        height: '8%',
        fieldName: 'subDesc',
        fontSize: '13px',
        style: guideStyles.description,
      },
      {
        id: 'pipeline',
        label: 'Pipeline Graph',
        description: '제품 개발 단계를 시각화하여 보여줍니다.',
        x: '10%',
        y: '85%',
        width: '80%',
        height: '12%',
        fieldName: 'pipeline',
        style: guideStyles.media,
      },
    ];
  }

  return {
    getMainVisualAreas,
    getBusinessAreas,
    getBusinessThumbnail,
    getTopCategoryAreas,
    getCategoryAreas,
  };
}

export default useGetGuideInfo;
